// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToFreeShippingsContent_wrapper__HZ_Z6","freeShippingContentSpinner":"ToFreeShippingsContent_freeShippingContentSpinner__kfWN7"};